// Libs
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import {
  Flexbox,
  ToolButton,
} from '@ibinder/common-frontend';

// Icons
import { plus, edit, delete as deleteIcon, fileCopy as documentCopy,eyeOpened} from '@ibinder/common-icons';

// Styles
const StyledActionbar = styled.div`
  margin: 0 -1rem;
  > *:first-child {
    > * {
      margin: 0.5rem;
    }
  }
`;

const ActionbarContent = styled(Flexbox)`
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid ${(p) => p.theme.colors.discrete60};
`;

const ExtraSpace = styled.span`
  margin-right: 0.75rem;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    display: none;
  }
`;

const ItemNo = styled.p``;

const Bold = styled.span`
  font-weight: bold;
  margin: 0 0.25rem;
`;


/* These match pattern expected by SingleSelect */
export const SORTING_VARIANTS = {
  ASC: 'ASC',
  DESC: 'DESC'
};

const Actionbar = ({
  selectedIds,
  createGlobalTypeTemplate,
  editGlobalTypeTemplate,
  duplicateGlobalTypeTemplate,
  labels,
  isDefaultTemplate,
  canCreate = true
}) => {
  return (
    <StyledActionbar>
      <ActionbarContent>
        {canCreate && selectedIds.length === 0 && (
          <ToolButton type="button" onClick={createGlobalTypeTemplate}>
            {plus}
            <ExtraSpace>{labels.createNew}</ExtraSpace>
          </ToolButton>
        )}
        {selectedIds.length === 1 && (<>
          {!isDefaultTemplate && (
          <ToolButton type="button" onClick={duplicateGlobalTypeTemplate}>
            {documentCopy}
            <ExtraSpace>{labels.duplicate}</ExtraSpace>
          </ToolButton>
          )}
          <ToolButton type="button" onClick={editGlobalTypeTemplate}>
            {isDefaultTemplate ? eyeOpened : edit } 
            <ExtraSpace>{isDefaultTemplate ? labels.view: labels.edit }</ExtraSpace>
          </ToolButton>
          </>
        )}
      </ActionbarContent>
    </StyledActionbar>
  );
};

export default Actionbar;
